// ./pages/About/index.jsx
import React from "react";
import Shoppingcartsubbanner from "../../components/shoppingcartsubbanner";
import Shoppingcartcarts from "../../components/shoppingcartcarts";

const Shoppingcart = () => {
  return (
    <>
     <Shoppingcartsubbanner />
     <Shoppingcartcarts />
    </>
  );
};

export default Shoppingcart;